/**
 * Created by Ivan on 29.05.2025
 */

const UndoBoosterTutorial = function () {
    return new TutorialScenario("undobooster", {
        listSteps: () => [
            UndoBoosterTutorial.createStep()
        ],
        isAvailable: () => {
            const undoBooster = cleverapps.boosters.getBoosterById(cleverapps.Boosters.TYPE_UNDO);

            if (!Game.currentGame || Game.currentGame.outcome !== GameBase.OUTCOME_UNKNOWN
                || !undoBooster.isForceAvailable()) {
                return false;
            }

            return Game.currentGame.log.isUndoNeedOnPreviousMove();
        },

        onStart: function () {
            const undoBlock = cleverapps.Scenes.GetSceneComponent(TriPeaksSceneComponent).undoBlock;

            undoBlock.priceBlock && undoBlock.priceBlock.setVisible(false);
        },
        onFinish: function () {
            const undoBlock = cleverapps.Scenes.GetSceneComponent(TriPeaksSceneComponent).undoBlock;

            undoBlock.priceBlock && undoBlock.priceBlock.setVisible(true);
            undoBlock.updateState();
        }
    });
};

UndoBoosterTutorial.createStep = function () {
    const undoBooster = cleverapps.boosters.getBoosterById(cleverapps.Boosters.TYPE_UNDO);
    const undoBlock = cleverapps.Scenes.GetSceneComponent(TriPeaksSceneComponent).undoBlock;
    return new TutorialStep({
        onStart: function () {
            cleverapps.focusManager.showControlsWhileFocused("undoBlock");

            new ActionPlayer([
                function (f) {
                    setTimeout(f, 500);
                },

                function (f) {
                    cleverapps.forces.create(undoBlock.undoButton, Object.assign(cleverapps.clone(undoBooster.force), {
                        finger: false,
                        pointer: true
                    }));
                    cleverapps.forces.onceForceClosed = f;
                },

                function (f) {
                    setTimeout(f, 100);
                },

                function (f) {
                    const missed = Game.currentGame.table.listMissed();
                    if (missed.length) {
                        this.tutorialCard = missed[0];
                        this.tutorialCard.trigger("showTutorial");
                    }
                    f();
                }.bind(this)
            ]).play();

            cleverapps.tutorial.on("executeBooster", this.finish.bind(this), this);
        },
        onFinish: function () {
            cleverapps.forces.closeRunningForce();
        }
    });
};